import { Navigate } from 'react-router-dom';
import * as api from '../api';
import {AUTH} from '../constants/actionTypes'


export const signin = (formData1,navigate)=> async (dispatch)=>{
    try {
      const {data} = await api.signIn(formData1);

        dispatch({type:AUTH,payload:data});
        navigate('/');

    } catch (error) {
        console.log(error);
    }
}

export const signup = (formData1,navigate)=> async (dispatch)=>{
    try {
        const {data} = await api.signUp(formData1);
        
        dispatch({type:AUTH,data});
        navigate('/admin/messages');

    } catch (error) {

        console.log(error);
    }
}